export default __webpack_public_path__ + "static/media/umbrella.ff8a60b6.webp";